<template>
  <div>
    <SectionTransition
      v-if="showWidget"
      has-content
      :reserve-height="trustpilotHeight"
      client-only
    >
      <Trustbox
        :template-id="widgetId"
        :locale="languageAndCountry"
        :style-height="trustpilotHeight"
        :theme="theme"
        class="w-full"
      />
    </SectionTransition>
    <ExternalLink
      v-else
      :url="TRUSTPILOT"
      :blank="true"
      class="h-full"
    >
      <ImgView
        :src="logoUrl"
        alt="Trustpilot"
        class="h-full"
      />
    </ExternalLink>
  </div>
</template>

<script lang="ts">


import { TRUSTPILOT_LOGOS, TRUSTPILOT_THEMES } from '~~/constants/trustPilot';
import { TRUSTPILOT } from '~~/constants/trustUrls';

export default defineComponent({
  name: 'TrustpilotWrapper',

  props: {
    widgetId: {
      type: String,
      required: true,
    },
    showWidget: {
      type: Boolean,
      default: true,
    },
    theme: {
      type: String as PropType<ValueOf<typeof TRUSTPILOT_THEMES>>,
      default: TRUSTPILOT_THEMES.LIGHT,
    },
    trustpilotHeight: {
      type: String,
      required: true,
    },
  },
  setup (props) {

    const { languageAndCountry } = useLocalization();

    const logoUrl = computed(() => {

      const logoColor = props.theme === TRUSTPILOT_THEMES.DARK
        ? TRUSTPILOT_LOGOS.WHITE
        : TRUSTPILOT_LOGOS.BLACK;

      return `/logos/trustpilot-logo-${logoColor}.svg`;
    
    });

    return {
      languageAndCountry,
      TRUSTPILOT,
      logoUrl,
    };
  
  },
});


</script>
